/*
 * @Author: freedeng
 * @Date: 2019-06-25 11:08:51
 * @Last Modified by: paddywu
 * @Last Modified time: 2019-12-20 16:43:32
 */
import { FILE_TYPE } from './PadInfo';
import { Log } from '../tools/Log';
var OFFLINE_ITEM_TYPE;
(function (OFFLINE_ITEM_TYPE) {
    OFFLINE_ITEM_TYPE["INIT"] = "init";
    OFFLINE_ITEM_TYPE["DOCUMENT"] = "document";
    OFFLINE_ITEM_TYPE["WORKBOOK"] = "workbook";
    OFFLINE_ITEM_TYPE["CHUNK"] = "chunk";
    OFFLINE_ITEM_TYPE["ACCEPTED"] = "accepted";
    OFFLINE_ITEM_TYPE["MISS_CHANGE"] = "misschange";
    OFFLINE_ITEM_TYPE["NEW_CHANGE"] = "newchange";
    OFFLINE_ITEM_TYPE["COMMITING"] = "commiting";
    OFFLINE_ITEM_TYPE["WATTING"] = "watting";
    OFFLINE_ITEM_TYPE["QUEUE"] = "queue";
})(OFFLINE_ITEM_TYPE || (OFFLINE_ITEM_TYPE = {}));
var OfflineData = /** @class */ (function () {
    function OfflineData(options) {
        this.chunkId = 0; // 子表分片号  子表可能会被分成多片 比如0-60行一片   61-200行一片
        this.default = false;
        if (!options.taskId) {
            options.taskId = OfflineData.createMessageSeq();
        }
        if (!options.key) {
            options.chunkId = options.chunkId || 0;
            if (options.type === OFFLINE_ITEM_TYPE.INIT) {
                options.key = options.globalPadId + '_' + options.subSheetId + '_' + options.uid; // 自动合成key值
            }
            else if (options.type === OFFLINE_ITEM_TYPE.DOCUMENT) {
                options.key = options.globalPadId + '_' + options.uid + '_version_' + options.version; // 自动合成key值
            }
            else if (options.type === OFFLINE_ITEM_TYPE.WORKBOOK) {
                options.key = options.globalPadId + '_' + options.subSheetId + '_' + options.uid + '_version_' + options.version; // 自动合成key值
            }
            else if (options.type === OFFLINE_ITEM_TYPE.CHUNK) {
                options.key = options.globalPadId + '_' + options.subSheetId + '_' + options.chunkId + '_' + options.uid + '_version_' + options.version; // 自动合成key值
            }
            else {
                options.key = options.globalPadId + '_' + options.subSheetId + '_' + options.uid + '_taskId_' + options.taskId; // 自动合成key值
            }
        }
        options.default = options.default || false;
        this.key = options.key;
        this.uid = options.uid;
        this.globalPadId = options.globalPadId;
        this.secretId = options.secretId;
        this.subSheetId = options.subSheetId;
        this.chunkId = options.chunkId;
        this.type = options.type;
        this.docType = options.docType;
        this.padStatus = options.padStatus;
        this.taskId = options.taskId;
        this.version = options.version;
        this.data = options.data || options._data;
        this.default = options.default;
        this.createTime = options.createTime;
        this.dver = options.dver;
    }
    OfflineData.createMessageSeq = function () {
        var randRange = 2147483648; // 4个byte
        var seq = Math.ceil(Math.random() * randRange);
        return seq;
    };
    OfflineData.prototype.disableConvert = function () {
        return this.docType === FILE_TYPE.WORD && this.subSheetId !== 'BB08J2';
    };
    Object.defineProperty(OfflineData.prototype, "data", {
        get: function () {
            if (typeof this._data === 'string' && !this.disableConvert()) {
                var result = this._data;
                try {
                    result = JSON.parse(this._data);
                }
                catch (error) {
                    Log.error(error);
                }
                return result;
            }
            return this._data;
        },
        set: function (data) {
            if (typeof data !== 'string') {
                this._data = JSON.stringify(data);
            }
            else {
                this._data = data;
            }
        },
        enumerable: false,
        configurable: true
    });
    return OfflineData;
}());
export { OFFLINE_ITEM_TYPE, OfflineData };
//# sourceMappingURL=OfflineData.js.map